import { SEGMENTS_FAMILY_NAME } from "app/components/widget/widget-utilities/segments/constants";
import { DEFAULT_DURATION_FOR_SEGMENTS, getShouldHideSegments } from "./utils";

export const Geography = {
    id: "SegmentsGeography",
    properties: {
        order: "8",
        dropdownOrder: 8,
        isHidden: getShouldHideSegments,
        endpoint: "api/segmentsGeography",
        dashboard: "true",
        title: "Traffic share by country",
        viewPermissions: {
            trafficSources: ["Desktop", "Total"],
        },
        family: SEGMENTS_FAMILY_NAME,
        component: "CustomSegments",
        isCountryFilterHidden: true,
        availabilityComponent: "WsSegmentAnalysis",
        state: "digitalsuite_segments-analysis-geography",
        periodOverPeriodSupport: false,
        noCompare: true,
        defaultDuration: DEFAULT_DURATION_FOR_SEGMENTS,
        options: {
            deviceFilteringUnavailable: true,
        },
    },
    widgets: {
        single: {
            defaultType: "SegmentsGeography",
            SegmentsGeography: {
                properties: {
                    showMoreButtonItems: 5,
                    options: {
                        showLegend: false,
                        dashboardSubtitleMarginBottom: 15,
                    },
                },
                filters: {
                    orderBy: [
                        {
                            value: "TrafficShare asc",
                            title: "Traffic Share",
                        },
                    ],
                    timeGranularity: [
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                },
            },
        },
    },
};
